import React from "react";
import { LoadAllNetworkSettings } from "../../../services/NetworkApi";
import useAuth from "../../login/AuthContext";
import DownloadCSVButton from "../../../common/component/DownloadCSVButton";
import { MainLayout } from "../../../layout/MainLayout";

export const NetworkSettingsContainer: React.FunctionComponent = () => {
  const { getAuthToken, isWriteAccess } = useAuth();

  return (
    <MainLayout title="Network Settings">
      {isWriteAccess() && (
        <div style={{ float: "left", marginLeft: "25px" }}>
          <DownloadCSVButton
            title="Download Network Dashboard"
            apiCall={async () => LoadAllNetworkSettings(await getAuthToken())}
            type="csv"
          />
        </div>
      )}
    </MainLayout>
  );
};

export const NETWORK_SETTINGS = "/super_admin/network_settings";
